// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2KeHM","content":"ManualTimeModal_content__5RTb9"};